/**
 * Get the display name for a document's workflow status
 * @param {Object} document - The document object
 * @param {Array} workflowStatuses - Array of workflow status configs from orgConfig
 * @returns {string} The display name for the status, or the status ID if not found
 */
export function getStatusDisplayName(document, workflowStatuses) {
  if (!document?.workflowStatus || !workflowStatuses) {
    return null;
  }

  const statusConfig = workflowStatuses.find(
    (s) => s.id === document.workflowStatus
  );

  return statusConfig?.name || document.workflowStatus;
}
